import ApiERP from '@/core/conectores/ApiERP';
import { IModulo, IModuloPermissao } from '@/models/Entidades/PainelAdministrativo/Modulos/IModulo';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { IPropriedadeConsulta } from '@/core/models/Consulta/PropriedadeConsulta';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { IServicoBase } from '@/core/models/IServicoBase';
import storeSistema from '@/store/storeSistema';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { IDTOModuloPermissao } from '@/models/DTO/MeuSistema/Modulos/IDTOModuloPermissao';
import { IItemGenerico } from '@/core/models/IItemGenerico';
/**
 * Serviço de Módulos
 * Fornece todas regras de negócios e lógicas relacionado a módulos.
 */

class ServicoModulo implements IServicoBase<IModulo> {
  endPoint = 'painel-administrativo/modulos';

  apiERP = new ApiERP();

  public requisicaoSistema():void {
    this.apiERP = new ApiERP(true);
  }

  public async obterTodos(): Promise<IModulo[]> {
    const result: any = await this.apiERP.get(`${this.endPoint}/todos`);
    return result.data;
  }

  public async obterListaIdentificadoresModulo(): Promise<IItemGenerico[]> {
    const result: any = await this.apiERP.get(`${this.endPoint}/identificadores`);
    return result.data;
  }

  public async obterPropriedadesConsulta(): Promise<IPropriedadeConsulta[]> {
    const listaTeste = await this.apiERP.obterPropriedadesConsulta(this.endPoint);
    return listaTeste;
  }

  public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida): Promise<IItemConsultaRapida[]> {
    return this.apiERP.consultaRapida(this.endPoint, parametrosConsultaRapida);
  }

  public async buscaAvancada(parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[]): Promise<IListaPaginada> {
    return this.apiERP.buscaAvancada(this.endPoint, parametrosConsulta, filtros);
  }

  public async relatorioPadrao(tipoArquivo: ETipoArquivo, parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[], codigosSelecionados?: Array<number>): Promise<IRetornoRelatorio> {
    return this.apiERP.relatorioPadrao(this.endPoint, tipoArquivo, parametrosConsulta, filtros, codigosSelecionados);
  }

  public async imprimirEtiquetaPadrao(codigoRegistro: number, empresa: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/etiqueta/${codigoRegistro}/empresa/${empresa}`);
    return result.data;
  }

  public obterIdentificacaoRegistroGradeCRUD(objeto: IModulo): string {
    return objeto.descricao;
  }

  public async incluir(modulo: IModulo): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}`, modulo);
    return result.data;
  }

  public async alterar(modulo: IModulo): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${modulo.codigo}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}`, modulo);
    return result.data;
  }

  public async atualizarPermissoes(codigoModulo:number, permissoes: IModuloPermissao[]): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${codigoModulo}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}/permissoes`, permissoes);
    return result.data;
  }

  public async obter(codigo: number): Promise<IModulo> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}`);
    return result.data;
  }

  public async obterPermissoes(codigo: number): Promise<IDTOModuloPermissao[]> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}/permissoes`);
    return result.data;
  }

  public async excluir(codigo: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}`);
    return result.data;
  }
}

export default ServicoModulo;
